import React from 'react';
import { createClasses } from '@kp/react-ui';
import {
  DialogTitle as MaterialDialogTitle,
  DialogTitleProps as MaterialDialogTitleProps,
  IconButton,
} from '@mui/material';
import * as Icons from '@mui/icons-material';

const classes = createClasses({
  closeButton: {
    position: 'absolute',
    right: 8,
    top: 8,
  },
});

export type ConfirmAlertProps = { closeButton?: boolean; onClose: () => void };

type DialogTitleProps = MaterialDialogTitleProps & {
  closeButton: boolean;
  onClose: () => void;
};

export const DialogTitle: React.FC<DialogTitleProps> = ({
  children,
  closeButton,
  onClose,
  ...other
}) => {
  return (
    <MaterialDialogTitle {...other}>
      {children}
      {closeButton && (
        <IconButton
          aria-label="close-button"
          data-testid="close-button"
          className={classes.closeButton}
          onClick={onClose}
        >
          <Icons.Close />
        </IconButton>
      )}
    </MaterialDialogTitle>
  );
};
